import React, { Component } from 'react'
import ShippingErrorPage from './ShippingErrorPage'

class ShippingErrorContainer extends Component {

    render() {

        return (
            <div className="ExportErrorShipping mt-4">
                <div className="d-sm-flex justify-content-between align-items-center">
                    <h1 className="PageTitle mb-3">Export error shipping</h1>
                </div>
                <div className="site-layout-background p-4">
                    <ShippingErrorPage />
                </div>
            </div>
        )
    }

}

export default ShippingErrorContainer